module.exports = __webpack_public_path__ + "img/logo.ce4c4588.png";